/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BridgeApiTemplateField } from './BridgeApiTemplateField';
import {
    BridgeApiTemplateFieldFromJSON,
    BridgeApiTemplateFieldFromJSONTyped,
    BridgeApiTemplateFieldToJSON,
    BridgeApiTemplateFieldToJSONTyped,
} from './BridgeApiTemplateField';

/**
 * Requested fields
 * @export
 * @interface BridgeApiConversationRequestedFields
 */
export interface BridgeApiConversationRequestedFields {
    /**
     * 
     * @type {Array<string>}
     * @memberof BridgeApiConversationRequestedFields
     */
    fromTemplate: Array<string>;
    /**
     * 
     * @type {Array<BridgeApiTemplateField>}
     * @memberof BridgeApiConversationRequestedFields
     */
    custom: Array<BridgeApiTemplateField>;
}

/**
 * Check if a given object implements the BridgeApiConversationRequestedFields interface.
 */
export function instanceOfBridgeApiConversationRequestedFields(value: object): value is BridgeApiConversationRequestedFields {
    if (!('fromTemplate' in value) || value['fromTemplate'] === undefined) return false;
    if (!('custom' in value) || value['custom'] === undefined) return false;
    return true;
}

export function BridgeApiConversationRequestedFieldsFromJSON(json: any): BridgeApiConversationRequestedFields {
    return BridgeApiConversationRequestedFieldsFromJSONTyped(json, false);
}

export function BridgeApiConversationRequestedFieldsFromJSONTyped(json: any, ignoreDiscriminator: boolean): BridgeApiConversationRequestedFields {
    if (json == null) {
        return json;
    }
    return {
        
        'fromTemplate': json['fromTemplate'],
        'custom': ((json['custom'] as Array<any>).map(BridgeApiTemplateFieldFromJSON)),
    };
}

export function BridgeApiConversationRequestedFieldsToJSON(json: any): BridgeApiConversationRequestedFields {
    return BridgeApiConversationRequestedFieldsToJSONTyped(json, false);
}

export function BridgeApiConversationRequestedFieldsToJSONTyped(value?: BridgeApiConversationRequestedFields | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fromTemplate': value['fromTemplate'],
        'custom': ((value['custom'] as Array<any>).map(BridgeApiTemplateFieldToJSON)),
    };
}

